import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3079">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3080">
        <div data-id="element-3081">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3082">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3083">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3084">
          <Card className="p-6" data-id="element-3085">
            <div className="flex items-center gap-4" data-id="element-3086">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3087">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3088" />
              </div>
              <div data-id="element-3089">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3090">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3091">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3092">
            <div className="flex items-center gap-4" data-id="element-3093">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3094">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3095" />
              </div>
              <div data-id="element-3096">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3097">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3098">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3099">
            <div className="flex items-center gap-4" data-id="element-3100">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3101">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3102" />
              </div>
              <div data-id="element-3103">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3104">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3105">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3106">
            <div className="flex items-center gap-4" data-id="element-3107">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3108">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3109" />
              </div>
              <div data-id="element-3110">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3111">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3112">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3113">
          <div className="p-6 border-b border-gray-200" data-id="element-3114">
            <h2 className="font-bold text-gray-900" data-id="element-3115">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3116">
            <table className="w-full text-left text-sm" data-id="element-3117">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3118">
                <tr data-id="element-3119">
                  <th className="px-6 py-4 font-medium" data-id="element-3120">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3121">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3122">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3123">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3124">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3125">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3126">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3127">
                {loading ? <tr data-id="element-3128">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3129">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3130">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3131">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3132">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3133">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3134">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3135">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3136">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3137">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3138">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3139">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3140">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}